import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import "../CSS/Template/Projects2.css"
import FooTer from "./footer"


export default function Projects2() {
    return (
        <>
            <Helmet>
                <title>Code Arindam | Projects</title>
            </Helmet>
            <div className="projects">
                <div className='mainDiv2'>
                    <p className="mainText">
                        StarLord The Music App
                    </p>
                    <p className="describe">
                        Creating A Music App With React Hope You All Guys Injoy This App.
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/Starload-Music">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://arindamk143.github.io/Starload-Music/">Open Website</a>
                    </div>
                </div>
                <div className='mainDiv2'>
                    <p className="mainText">
                        Solar Systems
                    </p>
                    <p className="describe">
                        Creating A solar sytem with THREE.JS so visit the site and feel the Galaxy
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/Solar-System">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://solar-system-ca.web.app">Open Website</a>
                    </div>
                </div>
                <div className='mainDiv2'>
                    <p className="mainText">
                        Find My Location
                    </p>
                    <p className="describe">
                        Creating A IP Location Tracker By Network
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/GetaboutU">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://arindamk143.github.io/GetaboutU/">Open Website</a>
                    </div>
                </div>
                <hr style={{ backgroundColor: "white" }} />
                <div className="page">
                    <Link to="/Projects">&laquo;</Link>
                    <Link to='/Projects' >1</Link>
                    <Link to='/Projects/Page-2' className='active'>2</Link>
                    <Link to='/Projects/Page-3' className='active'>3</Link>
                    <Link to="/Projects/Page-3">&raquo;</Link>
                </div>
            </div>
            <hr style={{ backgroundColor: "white" }} />
            <FooTer />
        </>
    )
}
